import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	allFields: {
		id: 'polaris-common.idea-card-v2.body.all-fields',
		defaultMessage: 'Open idea to see all fields',
		description: 'Hint to open idea to see all fields',
	},
});
